/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';
import ListReportWalletTransaction from '../views/report-wallet/ListReportWalletTransaction.vue';
import { setBreadcrumb } from './index';

const reportWalletTransactionRoute = {
  path: '/report-wallet-transaction',
  children: [
    {
      path: '',
      meta: {
        title: 'BNI QRIS - Report International Wallet',
        appBarTitle: 'Report International Wallet',
        breadcrumbs: () => [
          setBreadcrumb(
            'Report International Wallet',
            '/report-wallet-transaction',
            true
          ),
          setBreadcrumb(
            'List Report International Wallet',
            '/report-wallet-transaction'
          ),
        ],
      },
      component: ListReportWalletTransaction,
      name: 'ListReportWalletTransaction',
    },
  ],

  meta: {
    title: 'BNI QRIS - RBNI QRIS - Report International Wallet Transaction',
    appBarTitle: 'Report International Wallet Transaction',
  },
  component: Parent,
};
export default reportWalletTransactionRoute;
